import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash.isempty';
import { Space, Divider } from 'antd';

export const UserRoles = ({ roles }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!Array.isArray(roles) || isEmpty(roles) || !roles) return;
  }, [roles]);

  return <Space split={<Divider type='vertical' />}>{roles.map(role => t(`roles.${role}`))}</Space>;
};
